import PricingRulesPage from './PricingRulesPage'

export default PricingRulesPage
